import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import React from "react";

import { Dialog } from "@/common/components/dialog/dialog";
import { PropertiesList } from "@/common/components/properties-list/properties-list";

type BindingOfferDialogProps = {
  title?: React.ReactNode;
  introText: React.ReactNode;
  legalConsentText: React.ReactNode;
  tradingHoursText?: React.ReactNode;
  legalNoticeText: React.ReactNode;
  traderLabel?: string;
  traderName?: string;
  cropName: string;
  amount: string;
  quarter: string;
  parity: string;
  parameters?: string;
  unitPrice: string;
  isPending: boolean;
  confirmLabel: React.ReactNode;
  onConfirm: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onCancel: () => void;
};

const BindingOfferDialog = ({
  title,
  introText,
  legalConsentText,
  tradingHoursText,
  legalNoticeText,
  traderLabel,
  traderName,
  cropName,
  amount,
  quarter,
  parity,
  parameters,
  unitPrice,
  isPending,
  confirmLabel,
  onConfirm,
  onCancel,
}: BindingOfferDialogProps) => {
  const properties = [
    ...(traderLabel && traderName
      ? [{ label: traderLabel, value: traderName }]
      : []),
    { label: t`Název zboží`, value: cropName },
    { label: t`Množství`, value: amount },
    { label: t`Termín plnění`, value: quarter },
    { label: t`Parita`, value: parity },
    ...(parameters ? [{ label: t`Parametry`, value: parameters }] : []),
    { label: t`Jednotková cena (bez DPH)`, value: unitPrice },
  ];

  return (
    <Dialog>
      <div className="flex max-h-[calc(100dvh-6rem)] flex-col gap-y-6 overflow-y-auto">
        <Dialog.Title>{title ?? <Trans>Závazná nabídka</Trans>}</Dialog.Title>
        <p className="text-sm">{introText}</p>
        <PropertiesList properties={properties} />
        <p className="text-sm">{legalConsentText}</p>
        {tradingHoursText ? (
          <p className="text-sm">{tradingHoursText}</p>
        ) : null}
        <p className="text-sm">{legalNoticeText}</p>
      </div>
      <Dialog.Actions>
        <Dialog.Confirm disabled={isPending} onClick={onConfirm}>
          {confirmLabel}
        </Dialog.Confirm>
        <Dialog.Cancel onClick={onCancel}>
          <Trans>Zrušit</Trans>
        </Dialog.Cancel>
      </Dialog.Actions>
    </Dialog>
  );
};

export { BindingOfferDialog };
export type { BindingOfferDialogProps };
